module.exports = __webpack_public_path__ + "static/media/ePayIcon.b0c84a4a.svg";